import {
    CloseOutlined,
    EditOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, Drawer, Dropdown, Empty, Space, Spin, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Link from './components/Link';
import { useNavigate } from 'react-router-dom';
import useDsBreach from './hooks/useDsBreach';
import Card from './components/Card';
import PreviewForm from '../../../components/forms/preview';
import useQuery from '../../../util/useQuery';
import Outer from './components/Outer';
import { ICON } from './components/icon';
import History from './components/History';
import usePermission from '../../../hooks/usePermission';

export default function DataBreachForm() {
    const { t } = useTranslation('data-breach');
    const navigate = useNavigate();
    const params = useQuery();
    const groupId = params.get('id');
    const [selectKey, setSelectKey] = useState('lastUpdate');
    const [visible, setVisible] = useState(false);
    const [callHistory, setCallHistory] = useState(true);
    const [isChanged, setIsChanged] = useState(false);

    const {
        dsBreachList,
        dsBreachDetail,
        dataBreachService,
        getDataBreachFormById,
        getDataBreachFormPublichById,
        getDataBreachList,
        loading,
    } = useDsBreach({ isPreview: false });

    const items = [
        {
            key: '1',
            label: 'แบบฟอร์มสำเร็จรูป',
            onClick: () => navigate('/data-breach/form/edit'),
        },
        {
            key: '2',
            label: 'แบบฟอร์มใหม่',
            onClick: () => navigate('/data-breach/form/new'),
        },
    ];

    const onChange = (key) => setSelectKey(key);

    useEffect(() => {
        getDataBreachList();
    }, [getDataBreachList]);

    useEffect(() => {
        setSelectKey('lastUpdate');
    }, [groupId]);

    useEffect(() => {
        if (groupId) {
            if (selectKey === 'published') {
                getDataBreachFormPublichById(groupId);
            }

            if (selectKey === 'lastUpdate') {
                getDataBreachFormById(groupId);
            }
        }
    }, [
        getDataBreachFormById,
        groupId,
        selectKey,
        getDataBreachFormPublichById,
    ]);

    // set isChanged in dsBreachList
    useEffect(() => {
        if (dsBreachList.length > 0) {
            const dataBreach = dsBreachList.find(
                (item) => item.dataBreachGroupId === groupId
            );
            if (dataBreach) setIsChanged(dataBreach.isChanged);
            else setIsChanged(false);
        }
    }, [dsBreachList, groupId]);

    const style = dsBreachDetail?.style || {};
    const backgroundColor = style?.backgroundColor || '#EDEEF9';
    let jsonData = {};
    if (dsBreachDetail?.jsonData) {
        jsonData = JSON.parse(dsBreachDetail.jsonData);
    }

    const { isAuditor, isUser } = usePermission();

    const ShowLink = () => {
        if (isAuditor) return <div />;
        if (isUser) return <div />;
        if (dsBreachDetail) return <Link detail={dsBreachDetail} />;
        return <div />;
    };

    return (
        <div>
            <div>
                <div className="title">
                    แบบฟอร์มแจ้งเหตุละเมิดข้อมูลส่วนบุคคล
                </div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">Data Breach /</span>
                    <span> Data Breach Form</span>
                </div>
            </div>
            <div className="grid grid-cols-7 gap-4 mt-4">
                <div className="col-span-2 rounded-lg relative">
                    <div
                        className="bg-white"
                        style={{
                            borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                        }}
                    >
                        <div className="p-4 flex justify-between items-center">
                            <span className="text-[#65707A] font-semibold">
                                ทั้งหมด {dsBreachList.length} รายการ
                            </span>
                            <Dropdown
                                disabled={isAuditor || isUser}
                                menu={{
                                    items,
                                }}
                                placement="bottom"
                            >
                                <Button
                                    icon={<PlusCircleOutlined />}
                                    size="large"
                                    type="primary"
                                >
                                    สร้างฟอร์ม
                                </Button>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="bg-white overflow-y-auto overflow-x-hidden max-h-[60vh] h-max">
                        {dsBreachList.map((item) => (
                            <Card
                                detail={item}
                                key={item.dataBreachFormId}
                                action={() => getDataBreachList()}
                            />
                        ))}
                    </div>
                    {dsBreachList.length === 0 && (
                        <div className="absolute flex items-center justify-center h-full w-full">
                            <Empty
                                description={
                                    <span className="font-semibold text-lg">
                                        ยังไม่สร้างแบบฟอร์ม
                                    </span>
                                }
                            />
                        </div>
                    )}
                </div>
                <div className="col-span-5 space-y-4">
                    <div className="bg-white rounded-lg min-h-[60vh] h-max relative">
                        <div
                            style={{
                                borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                            }}
                        >
                            <div className="p-4 flex justify-between items-center">
                                <Space>
                                    <button
                                        onClick={() => {
                                            setCallHistory(true);
                                            setVisible(true);
                                        }}
                                    >
                                        {ICON[10]}
                                    </button>
                                    <span className="text-[#65707A] font-semibold">
                                        อัปเดตล่าสุด :{' '}
                                        {dsBreachDetail?.modifyBy} ,{' '}
                                        {dsBreachDetail?.modifyDate || '-'}
                                    </span>
                                </Space>
                                {dsBreachDetail && (
                                    <Button
                                        disabled={isAuditor || isUser}
                                        icon={<EditOutlined />}
                                        size="large"
                                        type="primary"
                                        onClick={() =>
                                            navigate(
                                                `/data-breach/form/edit?id=${groupId}`
                                            )
                                        }
                                    >
                                        แก้ไขฟอร์ม
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="px-6 pb-6 relative">
                            <Tabs
                                defaultActiveKey="lastUpdate"
                                activeKey={selectKey}
                                onChange={onChange}
                            >
                                <Tabs.TabPane
                                    tab="แก้ไขล่าสุด"
                                    key="lastUpdate"
                                >
                                    {dsBreachDetail && (
                                        <>
                                            <Outer />
                                            <Spin spinning={loading}>
                                                <div
                                                    style={{
                                                        backgroundColor,
                                                    }}
                                                    className="w-full h-[80vh] overflow-auto rounded-b-lg"
                                                >
                                                    <PreviewForm
                                                        justPreview
                                                        dataBreachFormId={
                                                            dsBreachDetail?.dataBreachFormId
                                                        }
                                                        style={style}
                                                        part={jsonData}
                                                    />
                                                </div>
                                            </Spin>
                                        </>
                                    )}
                                    {!dsBreachDetail && (
                                        <>
                                            <Outer />
                                            <div className="mt-60 absolute flex items-center justify-center h-full w-full">
                                                <Empty
                                                    description={
                                                        <span className="font-semibold text-lg">
                                                            ไม่พบข้อมูล
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                </Tabs.TabPane>
                                {isChanged && (
                                    <Tabs.TabPane
                                        tab="เผยแพร่แล้ว"
                                        key="published"
                                        className="relative"
                                    >
                                        {dsBreachDetail && (
                                            <>
                                                <Outer />
                                                <Spin spinning={loading}>
                                                    <div
                                                        style={{
                                                            backgroundColor,
                                                        }}
                                                        className="w-full h-[80vh] overflow-auto rounded-b-lg"
                                                    >
                                                        <PreviewForm
                                                            justPreview
                                                            dataBreachFormId={
                                                                dsBreachDetail?.dataBreachFormId
                                                            }
                                                            style={style}
                                                            part={jsonData}
                                                        />
                                                    </div>
                                                </Spin>
                                            </>
                                        )}
                                        {!dsBreachDetail && (
                                            <>
                                                <Outer />
                                                <div className="mt-60 absolute flex items-center justify-center h-full w-full">
                                                    <Empty
                                                        description={
                                                            <span className="font-semibold text-lg">
                                                                ไม่พบข้อมูล
                                                            </span>
                                                        }
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </Tabs.TabPane>
                                )}
                            </Tabs>
                        </div>
                    </div>
                    <ShowLink />
                </div>
            </div>
            <Drawer
                width={460}
                title={
                    <div className="flex justify-between items-center">
                        <span className="text-purple text-[17px]">
                            {t('History')}
                        </span>
                        <button
                            type="button"
                            onClick={(e) => setVisible(false)}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                }
                placement="right"
                onClose={() => setVisible(false)}
                closable={false}
                open={visible}
                className="history"
            >
                <History
                    callHistory={callHistory}
                    setCallHistory={setCallHistory}
                    service={dataBreachService.getHistoryDataBreach}
                />
            </Drawer>
        </div>
    );
}
